<template>
  <div class="trials-list">
    <Breadcrumbs :items="breadcrumbs" />

    <rp-trialtable
      :rows="rows"
      :pageInfo="pageInfo"
      @getTrials="getTrials"
      @onView="onView"
      @onExport="onExport"
      @onExtend="onExtend"
      @onClose="onClose" />

    <rp-overlay :active="showExtend">
      <rp-extendtrial
        v-model="extendTrial"
        @submit="submitExtend"
        @cancel="cancelExtend" />
    </rp-overlay>

    <rp-overlay :active="showConfirmClose">
      <rp-confirm
        icon="warning_rounded"
        :messageText="confirmCloseMessage"
        :confirm="doClose"
        :cancel="closeConfirm" />
    </rp-overlay>

  </div>
</template>

<script>
import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Confirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import TrialTable from 'raypro_ui/src/components/ui/TrialTable'
import ExtendTrial from 'raypro_ui/src/components/ui/forms/ExtendTrial'
import {getTrials, exportTrialCsv, adminExportTrialCsv, updateTrial, closeTrial} from 'raypro_ui/src/api/trials'
import {mapGetters} from 'vuex'

export default {
  mixins: [page],
  components: {
    'rp-button': Button,
    'rp-trialtable': TrialTable,
    'rp-extendtrial': ExtendTrial,
    'rp-alert': Alert,
    'rp-overlay': Overlay,
    'rp-confirm': Confirm,
    Breadcrumbs
  },

  data() {
    return {
      rows: [],
      pageInfo: {
        page_size: 10,
        page_number: 1
      },
      title: 'All Studies',
      breadcrumbs: [
        {label: 'All Studies'}
      ],
      showConfirmClose: false,
      confirmCloseMessage: '',
      closeId: '',
      extendId: '',
      extendTrial: {},
      showExtend: false,
    }
  },

  computed: {
    ...mapGetters(['authUser', 'isAdmin']),
  },

  mounted() {
    this.getTrials(this.pageInfo)
  },

  methods: {
    async getTrials(pageInfo) {
      let {data, page} = await getTrials(pageInfo)
      this.rows = data
      this.pageInfo = page
    },

    onView(row) {
      this.$router.push({name: 'view-study', params: {id: row.id}})
    },

    async onExport(row) {
      let data = null
      if (this.isAdmin) {
        data = await adminExportTrialCsv(row.id)
      } else {
        data = await exportTrialCsv(row.id, this.authUser.id)
      }

      this.downloadResult(data)
    },

    onExtend(row) {
      this.extendId = row.id
      this.showExtend = true
    },

    onClose(row) {
      this.closeId = row.id
      this.confirmCloseMessage = `Are you sure you want to close study ${row.name}?`
      this.showConfirmClose = true
    },

    async doClose() {
      this.showConfirmClose = false
      await closeTrial(this.closeId)
      await this.getTrials(this.pageInfo)
    },

    async submitExtend(payload) {
      this.showExtend = false
      await updateTrial(this.extendId, {trial: payload})
      await this.getTrials(this.pageInfo)
      this.extendTrial = {}
    },

    cancelExtend() {
      this.showExtend = false
      this.extendTrial = {}
    },

    closeConfirm() {
      this.showConfirmClose = false
    },

    downloadResult(result) {
      const disposition = result.headers['content-disposition']
      const matches = /"([^"]*)"/.exec(disposition)
      const filename = matches !== null && matches[1] ? matches[1] : 'file.csv'
      const blob = new Blob([result.data], {type: 'text/csv'})
      const link = document.createElement('a')

      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import 'raypro_ui/src/styles/base/_themes.scss'

  .table
    color: $color-text
    background-color: $color-panel-bg
    border-radius: 10px

    table
      padding: 10px
      width: 100%
      border-collapse: collapse
      table-layout: fixed

      td
        &.tdbutton
          width: 20px

        .status
          display: block

        div
          span
            display: flex
            justify-content: center

    thead
      @include themify($themes)
        background: themed('thead-background')
        color: themed('thead-color')

      font-weight: bold
      text-transform: uppercase
    
      td
        white-space: nowrap
        line-height: 1

        &.tdbutton
          text-align: center

        @include themify($themes)
          padding: themed('thead-td-padding')
          font-weight: themed('thead-td-weight')
          font-size: themed('thead-font-size')
          
        &:first-child 
          @include themify($themes)
            border-radius: themed('td-radius-left')

        &:last-child
          @include themify($themes)
            border-radius: themed('td-radius-right')

    tr
      @include themify($themes)
        border-bottom: themed('tr-border-bottom')
    
      &:first-child
        @include themify($themes)
          border-top: themed('tr-border-top')
      td
        @include themify($themes)
          padding: themed('td-padding')
        
        font-size: 12px
</style>



// WEBPACK FOOTER //
// src/components/pages/Clinical/Trials.vue